//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import React from 'react';
import styled from 'styled-components';

import { IContentLibraryItem } from '@apis/content-library/contentLibraryApiModel';
import { Dialog } from '@components/primitives/dialog/Dialog';
import { MEDIA_PANEL_WIDTH } from '@content-drawer/media/MediaPanel';
import { PreviewMedia } from '@content-drawer/media/PreviewMedia';

export interface PreviewPopupProps {
  item: IContentLibraryItem | undefined;
  onClose: () => void;
}

export const PreviewPopup = ({ item, onClose }: PreviewPopupProps) => (
  <>
    {item && (
      <PopupContent
        key={item.id} // Re-render the component when the user changes the media item to prevent video rendering issues.
        onInteractOutside={(event: Event) => {
          event.preventDefault(); // Do not close the preview popup on click outside because we might need to choose other media items.
        }}
        onEscapeKeyDown={(event: Event) => {
          event.preventDefault(); // Close the preview popup on Escape key down but keep the content drawer open.
          onClose();
        }}
      >
        <PreviewMedia item={item} onClose={() => onClose()} />
      </PopupContent>
    )}
  </>
);

const PopupContent = styled(Dialog.ContentWithoutPortal)(
  ({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: ${theme.spacings[0]};
    top: ${theme.spacings[0]};
    height: 100vh;
    width: calc(100vw - ${MEDIA_PANEL_WIDTH});
  `,
);
